import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';

import { AppConfigState } from './app-config-state.store';
import { mutations } from './app-config-mutations.store';
import { actions } from './app-config-actions.store';
import { IAppConfigState } from './app-config-types.store';
import { getters } from './app-config-getters.store';

export class AppConfigModule<RootState> implements Module<IAppConfigState, RootState>{
  namespaced: boolean;
  state: IAppConfigState;
  getters: GetterTree<IAppConfigState, RootState>;
  actions: ActionTree<IAppConfigState, RootState>;
  mutations: MutationTree<IAppConfigState>;
 
  constructor() {
    this.namespaced = true;
    this.state = new AppConfigState();
    this.mutations = mutations;
    this.actions = actions;
    this.getters = getters;
  }
}